<template>
  <div>
    <List>
      <input-focus inputType="text" v-model="name">
        {{ $l['userName'] }}
      </input-focus>

      <input-focus inputType="text" v-model="tel">
        {{ $l.userPhoneNumber }}
      </input-focus>

      <div class="item" @click="editBirthDay()">
        {{ $l['userBirthDay'] }}
        <span>{{ $store.getters['user/birthDay'] }}</span>
      </div>

      <div class="item" @click="selectCountry()">
        {{ $l.userCountry }}
        <span>{{ country }}</span>
      </div>

      <div class="item" @click="selectPrefecture()">
        {{ $l.userPrefecture }}
        <span>{{ prefecture }}</span>
      </div>

      <div class="item" @click="editAddress()">
        {{ $l['userAddress'] }}
        <span>{{ $store.getters['user/address'] }}</span>
      </div>
    </List>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import MixinLocale from '@/components/MixinLocale'
import List from '@/components/List'
import InputFocus from '@/components/InputFocus'
import _ from 'lodash'

export default {
  mixins: [ MixinLocale ],
  components: {
    List,
    InputFocus
  },
  computed: {
    name: {
      get: function () {
        return this.$store.state.user.name
      },
      set: _.debounce(function (name) {
        this.setName(name)
        this.$store.dispatch('user/saveName')
      }, 1000)
    },

    tel: {
      get: function () {
        return this.$store.state.user.tel
      },
      set: _.debounce(function (tel) {
        this.setTel(tel)
        this.$store.dispatch('user/saveTel')
      }, 1000)
    },

    country: function () {
      const country = this.$store.state.user.country
      if (country) {
        return country.get(this.locale)
      }
      return ''
    },

    prefecture: function () {
      const prefecture = this.$store.state.user.prefecture
      if (prefecture) {
        return prefecture.get(this.locale)
      }
      return ''
    }
  },

  methods: {
    ...mapMutations('user', [
      'setUsername',
      'setEmail',
      'setName',
      'setTel'
    ]),

    save: function () {
      this.$router.go(-1)
    },

    editBirthDay: function () {
      this.$store.dispatch('popup/show', 'birth-day')
    },

    selectCountry: function () {
      this.$store.dispatch('popup/show', 'user-country')
    },

    selectPrefecture: function () {
      this.$store.dispatch('popup/show', 'user-prefecture')
    },

    editAddress: function () {
      this.$store.dispatch('popup/show', 'user-address')
    },
  }
}
</script>
